import { RxDashboard } from "react-icons/rx";
import { BsClipboardData } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import { MdOutlineMoodBad } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { FiUser } from "react-icons/fi";

export const links = [
    {
        title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
        Icon: RxDashboard,
        to: "/",
    },
    {
        title: <FormattedMessage id="job-management" defaultMessage={"Job Management"} />,
        Icon: BsClipboardData,
        to: "/job-management",
    },
    {
        title: <FormattedMessage id="profile" defaultMessage={"Profile"} />,
        Icon: FiUser,
        to: "/profile",
    },
    
]